import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress, Container, Typography } from '@mui/material';
import abacusService, { TutorAbacusSessionDTO } from '../services/abacusService';

/** Both people open this path. It shows the session. It does not start a video call. */
const AbacusTutorJoinPage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const [session, setSession] = useState<TutorAbacusSessionDTO | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!sessionId) return;
      try {
        setSession(await abacusService.getTutorDeliverySession(Number(sessionId)));
      } catch {
        setError('This join link could not be opened.');
      }
    };
    void load();
  }, [sessionId]);

  if (error) {
    return (
      <Container sx={{ py: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Container>
    );
  }
  if (!session) {
    return (
      <Box minHeight="40vh" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={700} mb={1}>
        Tutor session
      </Typography>
      <Typography variant="body1" data-testid="tutor-prep-level">
        {`Learner level ${session.levelCode ?? 'not set'}`}
      </Typography>
      <Typography variant="body2" data-testid="tutor-session-join" sx={{ mt: 1 }}>
        {session.joinUrl}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        {`Status ${session.status}. No recording is stored.`}
      </Typography>
    </Container>
  );
};

export default AbacusTutorJoinPage;
